import React from 'react'

import { Col, Row } from '_zari/core'

import * as FormGroups from './formGroups'

const ComunSection = ({
  errors,
  touched,
  isSubmitting,
  handleChange,
  values,
  setFieldValue,
  setValues,
  nextNodeId
}) => {
  return (
    <>
      <Row>
        <Col md={8}>
          <FormGroups.CuentaContableFormGroup
            iError={errors.cuentaContable}
            iTouched={touched.cuentaContable}
            iValue={values.cuentaContableInfo}
            setFieldValue={setFieldValue}
            setValues={setValues}
            values={values}
          />
        </Col>
        <Col md={4}>
          <FormGroups.TipoCambioFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.tipoCambio}
            iFechaDocumento={values.fechaDocumento}
            iMoneda={values.moneda}
            iValue={values.tipoCambio}
            iTouched={touched.tipoCambio}
            setFieldValue={setFieldValue}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroups.GlosaFormGroup iValue={values.glosa} setFieldValue={setFieldValue} />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroups.ImporteDebeFormGroup
            fIsSubmitting={isSubmitting}
            handleChange={handleChange}
            iError={errors.importeDebe}
            iTouched={touched.importeDebe}
            setFieldValue={setFieldValue}
          />
        </Col>
        <Col md={4}>
          <FormGroups.ImporteHaberFormGroup
            fIsSubmitting={isSubmitting}
            handleChange={handleChange}
            iError={errors.importeHaber}
            iTouched={touched.importeHaber}
            setFieldValue={setFieldValue}
          />
        </Col>
        <Col md={4}>
          <FormGroups.MonedaFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.moneda}
            iTouched={touched.moneda}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroups.TipoAfectacionFormGroup
            iError={errors.tipoAfectacion}
            iTouched={touched.tipoAfectacion}
            fIsSubmitting={isSubmitting}
            afectacionCompras={
              values.cuentaContable
                ? values.cuentaContable.startsWith('4') ||
                  values.cuentaContable.startsWith('6') ||
                  values.cuentaContable.startsWith('9')
                : false
            }
            nextNodeId={nextNodeId}
            tieneCentroCosto={values.flagCentroCosto}
          />
        </Col>
        {values.flagCentroCosto && (
          <Col md={6}>
            <FormGroups.CentroCostoFormGroup
              fIsSubmitting={isSubmitting}
              handleChange={handleChange}
              iError={errors._idCentroCosto}
              iTouched={touched._idCentroCosto}
              nextNodeId={nextNodeId}
              setFieldValue={setFieldValue}
            />
          </Col>
        )}
      </Row>
    </>
  )
}

export default React.memo(ComunSection)
